import { useMatches } from '@tanstack/react-router';
import { AppError } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const useRouteTitle = () => {
    const matches = useMatches();
    const match = matches.at(-1);

    if (!match) throw new AppError('Match not found');

    const { loaderData, context } = match;
    const { localizeText } = context;

    const title =
        /**
         * In RARE cases (ie. customer detail) we might need a different browser tab title than the route title
         * yet we still need to use the route title in the breadcrumbs or tabs, we can set documentTitle on the route
         * and it will be set here.
         */
        (loaderData != null && 'documentTitle' in loaderData && loaderData.documentTitle().length > 0
            ? loaderData.documentTitle()
            : undefined) ??
        /**
         * We should be able to use isMatch from @tanstack/react-router to narrow the match in the filter above.
         * However, for whatever reason, the isMatch does not allow me to match `loaderData.title` here.
         * Maybe we need to define the loaderData types somewhere? 🤷‍♂️
         */
        (loaderData != null && 'title' in loaderData ? loaderData.title() : undefined) ??
        localizeText(
            context?.getTitle?.() ??
                (match.staticData.title !== undefined ? { textKey: match.staticData.title } : { textKey: TextKey.Mews })
        );

    return title;
};
